<template>
  <div class="hm-card investments" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>About Your Bank and Investment Accounts</h2>
      <p>Include money from accounts such as checking, savings, stocks, and bonds that you and/or your spouse have.</p>
    </div>
    <SuiDivider inverted v-if="($template === 'small')"/>
    <div class="max-w">
      <div
        :class="{ 'large-icons-block': ($template === 'article') }">
        <SuiButton
          basic
          color="grey"
          class="large-icon full-width"
          @mouseover="above = 'Above_green'"
          @mouseleave="above = 'Above'"
          :class="{ 'article': ($template === 'article') }"
          @click="onClickMoreThan">
          <img :src="`//hm-lis.herokuapp.com/img/svg/${above}.svg`" alt="image" class="large-icon">
          <span>I Have $14,610 or More / <br/>We Have $28,720 or More</span>
        </SuiButton>
        <SuiButton
          basic
          color="grey"
          class="large-icon full-width"
          @mouseover="below = 'Below_green'"
          @mouseleave="below = 'Below'"
          :class="{ 'article': ($template === 'article') }"
          @click="onClickLessThan">
          <img :src="`//hm-lis.herokuapp.com/img/svg/${below}.svg`" alt="image" class="large-icon">
          <span>I Have Less Than $14,610 / <br/>We Have Less Than $28,720</span>
        </SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';
  import {Divider} from 'semantic-ui-vue/dist/commonjs/elements/Divider';

  export default {
    name: 'BankAndInvestment',
    components: {
      SuiButton: Button,
      SuiDivider: Divider,
    },
    data() {
      return {
        above: 'Above',
        below: 'Below',
      }
    },
    methods: {
      onClickMoreThan() {
        this.$store.commit('setMoreThan14390', true);
        this.goNextStep('final');
      },
      onClickLessThan() {
        this.$store.commit('setMoreThan14390', false);
        this.goNextStep('household-income');
      },
      goNextStep(step) {
        this.$store.commit('setStep', step);
        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  .large-icon {
    &.circle-check {
      background-image: url('//hm-lis.herokuapp.com/img/svg/Above.svg');
    }
    &.circle-times {
      background-image: url('//hm-lis.herokuapp.com/img/svg/Below.svg');
    }
  }

</style>
